/* requires:
polyfill.js
*/

(function () {
  var options = {
    valueNames: ['name', 'subject', 'description-wrap', { data: ['tags'] }],
    page: 12,
    pagination: true,
  };
  const courseList = new List('course-catalog', options);
  const activeFilters = [];

  // sort
  courseList.on('updated', function (item) {
    if (item.matchingItems.length > 0) {
      document.querySelector('.no-result').style.display = 'none';
    } else {
      document.querySelector('.no-result').style.display = 'block';
    }
  });

  // filtering via checkbox
  const applyFilter = (filterElement) => {
    const value = filterElement.getAttribute('data-value');
    if (filterElement.checked) {
      activeFilters.push(value);
    } else {
      activeFilters.splice(activeFilters.indexOf(value), 1);
    }

    courseList.filter(function (item) {
      if (activeFilters.length > 0) {
        const itemSubject = item.values().subject.split(',');
        // check if any of the item subject is part of the applied filters
        // show products that matched ANY of the filters - additive filter
        return activeFilters.some((value) => itemSubject.includes(value));

        // show products that matched ALL filters selected - subtractive filter
        // return activeFilters.every((value) => itemSubject.includes(value));
      }
      return true;
    });
  };

  // const filterInputCollection = document.querySelectorAll('input.filter');
  // for (let filterInput of filterInputCollection) {
  //   filterInput.addEventListener('change', (event) => {
  //     applyFilter(event.currentTarget);
  //   })
  // }

  const filterInputCollection = document.querySelectorAll('.product-filter');
  for (let filterInput of filterInputCollection) {
    filterInput.addEventListener('click', (event) => {
      if (!event.target.classList.contains('filter')) return;
      applyFilter(event.target);
    });
  }

  const courseCatalogEl = document.getElementById('course-catalog');
  document.addEventListener(
    'click',
    function (event) {
      if (!event.target.closest('.page') && !event.target.closest('.pagination')) return;
      courseCatalogEl.scrollIntoView();
    },
    false
  );
})();

// filter accordion Toggle
const filterOpenClass = 'is-open';
const filterCloseClass = 'is-close';
const filterToggleCollection = document.querySelectorAll('.filter-accordion .filter-accordion-toggle');
const filterAccordionCollection = document.querySelectorAll('.filter-accordion');
for (let accordionToggle of filterToggleCollection) {
  accordionToggle.addEventListener('click', function () {
    const accordion = accordionToggle.closest('.filter-accordion');
    if (!accordion.classList.contains(filterOpenClass)) {
      accordion.classList.toggle(filterOpenClass);
      accordion.classList.toggle(filterCloseClass);
    } else if (accordion.classList.contains(filterOpenClass)) {
      accordion.classList.remove(filterOpenClass);
      accordion.classList.add(filterCloseClass);
    }
  });
}
// closing accordion on mobile
// if (window.innerWidth >= 850) {
//   for (let filterAccordion of filterAccordionCollection) {
//     filterAccordion.classList.add(filterOpenClass)
//     filterAccordion.classList.remove(filterCloseClass)
//   }
// }
// else {
//   for (let filterAccordion of filterAccordionCollection) {
//     filterAccordion.classList.remove(filterOpenClass)
//     filterAccordion.classList.add(filterCloseClass)
//   }
// }

// showing.hidding course filters
const courseFilterDiv = document.querySelector('#course-filters .product-filter');
const hideFiltersEl = document.querySelectorAll('#course-filters .hide-filters');
const showFiltersEl = document.querySelectorAll('.show-filters');
const docBody = document.body;

const showFilters = () => {
  const backdrop = document.createElement('div');
  backdrop.setAttribute('class', 'filter-backdrop');
  backdrop.setAttribute(
    'style',
    'position: fixed; top: 0; left: 0; width: 100vw; height: 100vh; background-color: rgba(0,0,0,.7); z-index: 1200;'
  );
  docBody.appendChild(backdrop);
  courseFilterDiv.classList.add('is-shown');
};
const hideFilters = () => {
  const backdrop = document.querySelector('.filter-backdrop');
  backdrop && backdrop.remove();
  courseFilterDiv.classList.remove('is-shown');
};

for (let showFilter of showFiltersEl) {
  showFilter.addEventListener('click', (event) => {
    event.preventDefault();
    showFilters();
  });
}
for (let hideFilter of hideFiltersEl) {
  hideFilter.addEventListener('click', (event) => {
    event.preventDefault();
    hideFilters();
  });
}

let resizeFilterTimer;
window.addEventListener(
  'resize',
  function () {
    clearTimeout(resizeFilterTimer);
    resizeFilterTimer = setTimeout(function () {
      if (menuToggle.offsetWidth <= 0 && menuToggle.offsetHeight <= 0) {
        hideFilters();
      }
    }, 250);
  },
  false
);

document.addEventListener('DOMContentLoaded', function () {
  // Create modal if it doesn't exist
  function createQuickViewModal() {
    if (document.getElementById('quickViewModal')) return;

    const modal = document.createElement('div');
    modal.id = 'quickViewModal';
    modal.className = 'modal fade';
    modal.tabIndex = -1;
    modal.setAttribute('aria-labelledby', 'quickViewModalLabel');
    modal.setAttribute('aria-hidden', 'true');
    modal.innerHTML = `
  <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
    <div class="modal-content p-0">
      <button type="button" class="btn-close position-absolute end-0 mt-2 me-2 z-2" data-bs-dismiss="modal" aria-label="Close"></button>
      <div class="row p-3 p-lg-4 g-0 align-items-top">
        <div class="d-none d-lg-block col-md-4 pt-md-3 pt-lg-4 text-center">
          <img id="quickview-img" class="img-fluid rounded" src="" alt="" />
        </div>
        <div class="col-lg-8 p-md-3 p-lg-4">
          <p id="quickview-title" class="h3"></p>
          <div class="d-flex align-items-center">
            <span id="quickview-regular-price" class="regular-price slashprice me-2 d-none" data-pid=""></span>
            <span id="quickview-price" class="price-display text-theme-primary fs-4 fw-bold" data-pid=""></span>
          </div>
          <div id="quickview-description" class="mt-3 mb-0 small"></div>
          <div class="mt-2 mb-4">
            <a id="quickview-link" href="#">&raquo; View Course</a>
          </div>
          <!--
          <div class="mb-3">
            <label for="quickview-qty" class="form-label fw-600 mb-1">Quantity</label>
            <div class="input-group qty-input-group">
              <button id="quickview-qty-decrement" class="qty-btn btn btn-sm btn-light" type="button" aria-label="Decrement">-</button>
              <input id="product-qty-modal" class="qty-input form-control text-center" type="number" name="quantity" min="1" value="1" aria-label="Quantity">
              <button id="quickview-qty-increment" class="qty-btn btn btn-sm btn-light" type="button" aria-label="Increment">+</button>
            </div>
          </div>
          -->
          <div class="mt-auto d-flex gap-2">
            <a id="quickview-get-team-access" class="cta-btn dark" href="/training-request">Get Team Access</a>
            <a id="quickview-addcart" class="cta-btn blue outline" href="#" data-pid="" data-cart="add">Buy This Course</a>
          </div>
        </div>
      </div>
    </div>
  </div>
`;
    document.body.appendChild(modal);
  }

  // Event delegation for quick view overlays
  document.body.addEventListener('click', function (e) {
    const quickView = e.target.closest('.quick-view-overlay');
    if (!quickView) return;

    e.preventDefault();
    createQuickViewModal();

    // Find the parent card
    const card = quickView.closest('.card');
    if (!card) return;

    const img = card.querySelector('img');
    const title = card.querySelector('.name')?.textContent;
    const description = card.querySelector('.product-description')?.textContent;
    const price = card.querySelector('.price-display')?.textContent;
    const regularPriceEl = card.querySelector('.regular-price');
    const regularPrice = regularPriceEl?.textContent;
    const regularPriceHasDisplayNone = regularPriceEl?.classList.contains('d-none');
    const productLink = card.querySelector('a.border-0')?.getAttribute('href');
    const priceDisplay = card.querySelector('.price-display');
    const pid = priceDisplay?.getAttribute('data-pid');
    // Generate the Add to Cart href using the same logic as cart.initAddToCartBtns
    let addToCartHref = '#';
    if (window.cart && typeof cart.readCookie === 'function' && typeof cart.cartBaseUrl === 'string') {
      const cartCookie = cart.readCookie('cartId');
      const testPrice = cart.readCookie('_up4tp') ? `&tp=${cart.readCookie('_up4tp')}` : '';
      const couponCode = cart.readCookie('_up4cc') ? `&coupon=${cart.readCookie('_up4cc')}` : '';
      const groupId = cart.readCookie('_up4gid') ? `&groupId=${cart.readCookie('_up4gid')}` : '';
      addToCartHref = `${cart.cartBaseUrl}/cart/?productId=${pid}${testPrice}${couponCode}${groupId}`;
    }

    const modal = document.getElementById('quickViewModal');
    if (modal) {
      const quickviewAddCartBtn = modal.querySelector('#quickview-addcart');
      if (quickviewAddCartBtn) {
        // Always close modal if the button has view-cart-btn and is clicked
        quickviewAddCartBtn.addEventListener('click', function (e) {
          if (
            quickviewAddCartBtn.classList.contains('view-cart-btn') ||
            quickviewAddCartBtn.classList.contains('update-cart-btn')
          ) {
            const bsModal = bootstrap.Modal.getInstance(modal);
            if (bsModal) {
              bsModal.hide();
            }
          }
        });
      }
    }
    modal.querySelector('#quickview-img').src = img?.src;
    modal.querySelector('#quickview-img').alt = img?.alt;
    modal.querySelector('#quickview-title').textContent = title;
    modal.querySelector('#quickview-description').textContent = description;

    const modalRegularPriceEl = modal.querySelector('#quickview-regular-price');
    const modalPriceEl = modal.querySelector('#quickview-price');

    modalRegularPriceEl.setAttribute('data-pid', pid);
    modalPriceEl.setAttribute('data-pid', pid);

    // If the card's regular-price has "display-none", add that class to the modal element
    if (!regularPriceHasDisplayNone) {
      modalRegularPriceEl.classList.remove('d-none');
    } else {
      modalRegularPriceEl.classList.add('d-none');
    }

    modalRegularPriceEl.textContent = regularPrice || '';
    modalPriceEl.textContent = price || '';
    modal.querySelector('#quickview-link').href = productLink;
    modal.querySelector('#quickview-addcart').setAttribute('data-pid', pid);
    modal.querySelector('#quickview-addcart').href = addToCartHref;

    // Set the correct ID for the qty input so cart.initQtyButtons() works
    // const qtyInput = modal.querySelector('#product-qty-modal');
    // if (qtyInput && pid) {
    //   qtyInput.id = `product-qty-${pid}`;
    // }

    // Set the Get Team Access link with product title as query string (lowercase, hyphens)
    const getTeamAccessBtn = modal.querySelector('#quickview-get-team-access');
    if (getTeamAccessBtn && title) {
      // Convert title to lowercase and replace spaces and consecutive whitespace with hyphens
      const productSlug = title.trim().replace(/\s+/g, '-');
      getTeamAccessBtn.href = `/training-request?product=${productSlug}`;
    }
    // Ensure the modal Add to Cart button reflects current cart state (View in Cart if already added)
    if (window.cart && typeof cart.initAddToCartBtns === 'function') {
      cart.initAddToCartBtns();
    }

    // Show modal
    const bsModal = new bootstrap.Modal(modal);
    bsModal.show();

    // Remove modal from DOM when closed
    modal.addEventListener('hidden.bs.modal', function () {
      modal.remove();
    });

    // Initialize qty buttons in the modal
    // if (window.cart && typeof cart.initQtyButtons === 'function') {
    //   cart.initQtyButtons();
    // }
  });

  // Pre-apply filters from URL params
  const params = new URLSearchParams(window.location.search);
  const categories = params.get('category');
  if (categories) {
    const categoryList = categories.split(',').map((c) => c.trim().toLowerCase());
    categoryList.forEach((category) => {
      const checkbox = document.querySelector(`input.filter[data-value="${category}"]`);
      if (checkbox && !checkbox.checked) {
        checkbox.checked = true;
        checkbox.dispatchEvent(new Event('click', { bubbles: true }));
      }
    });
  }
});
